import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { CalendarExternal as CalendarExternalComponent } from '../../features/calendar-external'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { useLocation, useParams } from 'react-router-dom'

type CalendarExternalProps = {
  id?: string
  selectedDate?: Date
} & RouteProps

export function CalendarExternal(props: CalendarExternalProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const location = useLocation()

  setTitle(title)

  const state: CalendarExternalProps = location?.state as CalendarExternalProps

  const { id } = useParams()

  return (
    <>
      <CalendarExternalComponent
        selectedDate={state?.selectedDate || new Date()}
        externalProfessionalID={id}
      />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
